import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AdvancedSearchClearComponent } from './components/advanced-search-clear/advanced-search-clear.component';
import { AdvancedSearchComponent } from './components/advanced-search.component';
import { AdvancedSearchInfoComponent } from './components/advanced-search-info/advanced-search-info.component';
import { AdvancedSearchUndoComponent } from './components/advanced-search-undo/advanced-search-undo.component';
import { AdvancedSearchInnerLogicalOperatorComponent } from './components/advanced-search-inner-logical-operator/advanced-search-inner-logical-operator.component';
import { AdvancedSearchInputComponent } from './components/advanced-search-input/advanced-search-input.component';
import { AdvancedSearchLabelComponent } from './components/advanced-search-label/advanced-search-label.component';
import { AdvancedSearchLogicalOperatorComponent } from './components/advanced-search-logical-operator/advanced-search-logical-operator.component';
import { AdvancedSearchSubmitComponent } from './components/advanced-search-submit/advanced-search-submit.component';
import { AdvancedSearchToggleOperatorComponent } from './components/advanced-search-toggle-operator/advanced-search-toggle-operator.component';

@NgModule({
  declarations: [
    AdvancedSearchClearComponent,
    AdvancedSearchComponent,
    AdvancedSearchInfoComponent,
    AdvancedSearchUndoComponent,
    AdvancedSearchInnerLogicalOperatorComponent,
    AdvancedSearchInputComponent,
    AdvancedSearchLabelComponent,
    AdvancedSearchLogicalOperatorComponent,
    AdvancedSearchSubmitComponent,
    AdvancedSearchToggleOperatorComponent
  ],
  imports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatTooltipModule
  ],
  exports: [MatButtonModule, MatAutocompleteModule, AdvancedSearchComponent, MatChipsModule, MatIconModule]
})
export class AdvancedSearchModule {}
